$(function () {
  if (!customElements.get('cart-select-menu')) {
    customElements.define(
      'cart-select-menu',
      class CartSelectMenu extends HTMLElement {
        constructor() {
          super();
          this.container = null;
          this.header = null;
          this.valueSpan = null;
          this.optionsList = null;
          this.optionsContainer = null;
          this.arrowIcon = null;
          this.$current_inventory_quantity = 0;
          this.$currentPrice = 0;
          this.$currentId = 0;
          this.$currentComparePrice = 0;
          this.$currentRecommendId = 0;
          this.$currentQuantity = 1;
          this.productId = null;
          this._documentClickBound = false;
          this.totalPrice = 0;
          this.totalComparePrice = 0;
          this.totalDiscount = 0;
          this.priceContribution = {
            price: 0,
            comparePrice: 0,
            discount: 0,
          };
          this.$cartRecommentSwiper = null;
        }

        connectedCallback() {
          // 为每个 select-menu 单独初始化
          const selectHeaders = this.querySelectorAll('.select-header');
          selectHeaders.forEach((header) => {
            // 获取相关元素
            const valueSpan = header.querySelector('.select-value');
            const optionsContainer = header.nextElementSibling;
            const arrowIcon = header.querySelector('.arrow-icon');
            const optionsList = optionsContainer?.querySelector('ul');

            // 存储元素引用到 header 上，方便后续使用
            header._elements = {
              valueSpan,
              optionsContainer,
              arrowIcon,
              optionsList,
            };

            // 绑定事件
            if (header && optionsContainer) {
              // 点击 header 展开/收起
              header.addEventListener('click', (e) => {
                e.stopPropagation();
                const elements = header._elements;
                this.toggle(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
              });

              // 点击选项
              optionsList?.addEventListener('click', (e) => {
                const option = e.target.closest('.select-option');
                if (option) {
                  e.stopPropagation();
                  const inventoryQuantity = option.getAttribute('data-inventory_quantity');
                  if (inventoryQuantity != 0) {
                    const elements = header._elements;
                    this.selectOption(option, header, elements);
                  }
                }
              });
            }
          });

          // 点击外部关闭所有下拉
          this.addEventListener('click', () => {
            selectHeaders.forEach((header) => {
              const elements = header._elements;
              if (elements) {
                this.close(header, elements.optionsContainer, elements.valueSpan, elements.arrowIcon);
              }
            });
          });

          // Swiper 初始化
          this.$cartRecommentSwiper = this.querySelector('.cart-recommend-swiper');
          if (this.$cartRecommentSwiper) {
            this.initSwiper();
            this.initEveryOption();
          }

          // 初始化加入购物车按钮
          this.initJoinCartButton();
        }

        toggle(header, optionsContainer, valueSpan, arrowIcon) {
          const isActive = header.classList.contains('active-select-menu');

          if (!isActive) {
            // 展开
            header.classList.add('active-select-menu');
            optionsContainer.style.maxHeight = '300px';
            optionsContainer.style.opacity = '1';
            optionsContainer.classList.add('!max-h-[300px]', '!opacity-100');
            valueSpan.style.color = '#acacac';
            arrowIcon.style.transform = 'rotate(-180deg)';
          } else {
            // 收起
            this.close(header, optionsContainer, valueSpan, arrowIcon);
          }
        }

        close(header, optionsContainer, valueSpan, arrowIcon) {
          header.classList.remove('active-select-menu');
          optionsContainer.style.maxHeight = '0';
          optionsContainer.style.opacity = '0';
          optionsContainer.classList.remove('!max-h-[300px]', '!opacity-100');
          valueSpan.style.color = '';
          arrowIcon.style.transform = '';
        }

        selectOption(option, header, elements) {
          const { valueSpan, optionsContainer, arrowIcon, optionsList } = elements;

          // 找到当前选项所在的 select-menu 容器
          const currentSelectMenu = option.closest('cart-select-menu');
          if (!currentSelectMenu) return;

          // 更新选中状态
          optionsList.querySelectorAll('.select-option').forEach((opt) => {
            opt.classList.remove('text-orange-500', 'selected');
          });
          option.classList.add('text-orange-500', 'selected');
          valueSpan.textContent = option.textContent;
          console.log('option-inventory_quantity', option.getAttribute('data-inventory_quantity'));
          // 更新当前选中项的价格和库存信息
          this.$current_inventory_quantity =
            option.getAttribute('data-inventory_quantity') != 0
              ? parseInt(option.getAttribute('data-inventory_quantity'))
              : 1;
          this.$currentPrice = this.parsePriceString(option.getAttribute('data-price'));
          this.$currentId = this.parsePriceString(option.getAttribute('data-id'));
          this.$currentComparePrice = this.parsePriceString(option.getAttribute('data-compare_at_price'));

          // 获取当前产品的 ID
          const currentProductId = option.getAttribute('data-recommend-id');
          this.productId = currentProductId;

          // 在当前 select-menu 中查找对应产品的 option-container
          const optionContainer = currentSelectMenu.querySelector(
            `.option-container[data-product-id="${currentProductId}"]`
          );

          if (optionContainer) {
            const quantityInput = optionContainer.querySelector('input[type="text"]');
            if (quantityInput) {
              // 更新最大值
              quantityInput.max = this.$current_inventory_quantity;

              // 检查当前数量是否超过新的最大值
              const currentQuantity = parseInt(quantityInput.value);
              if (currentQuantity > this.$current_inventory_quantity) {
                // 如果超过了，将数量调整为新的最大值
                quantityInput.value = this.$current_inventory_quantity;
                this.$currentQuantity = this.$current_inventory_quantity;
              } else {
                // 如果没超过，保持当前数量
                this.$currentQuantity = currentQuantity;
              }
            }
          }

          // 更新价格显示
          this.updateOptionPrice();

          // 关闭下拉
          this.close(header, optionsContainer, valueSpan, arrowIcon);
        }

        initEveryOption() {
          // 获取所有选项列表
          const lists = this.querySelectorAll('.select-options-list');

          lists.forEach((list) => {
            // 获取当前列表的第一个选项
            const firstOption = list.querySelector('.select-options-item');
            if (!firstOption) return;

            // 获取当前产品的信息
            const current_inventory_quantity = firstOption.getAttribute('data-inventory_quantity');
            const currentPrice = this.parsePriceString(firstOption.getAttribute('data-price'));
            const currentId = this.parsePriceString(firstOption.getAttribute('data-id'));
            const currentComparePrice = this.parsePriceString(firstOption.getAttribute('data-compare_at_price'));
            const currentRecommendId = this.parsePriceString(firstOption.getAttribute('data-recommend-id'));

            // 找到对应的数量输入框容器
            const quantityContainer = this.querySelector(`.option-container[data-product-id="${currentRecommendId}"]`);
            if (!quantityContainer) return;

            // 设置对应的数量输入框
            const quantityInput = quantityContainer.querySelector('input[type="text"]');
            if (quantityInput) {
              // 设置最大值
              quantityInput.max = current_inventory_quantity;

              // 监听输入事件
              quantityInput.addEventListener('input', (event) => {
                let newValue = parseInt(event.target.value);
                const maxValue = parseInt(quantityInput.max);

                // 限制输入范围
                if (isNaN(newValue) || newValue < 1) {
                } else if (newValue > maxValue) {
                  newValue = maxValue;
                  quantityInput.value = maxValue;
                }

                // 只在有效范围内更新价格
                if (newValue >= 1 && newValue <= maxValue) {
                  this.$currentQuantity = newValue;
                  this.updateOptionPrice();
                }
              });

              // 失去焦点时确保数值正确
              quantityInput.addEventListener('blur', () => {
                let value = parseInt(quantityInput.value);
                const maxValue = parseInt(quantityInput.max);

                if (isNaN(value) || value < 1) {
                  value = 1;
                } else if (value > maxValue) {
                  value = maxValue;
                }

                quantityInput.value = value;
                this.$currentQuantity = value;
                this.updateOptionPrice();
              });
            }
          });
        }
        // 更新价格显示
        updateOptionPrice() {
          // 使用唯一的类名选择器
          const priceElement = this.querySelector(`.select-price-${this.productId}`);
          const comparePriceElement = this.querySelector(`.select-compare-price-${this.productId}`);

          if (priceElement && this.$currentPrice && this.$currentQuantity) {
            // 更新价格显示
            priceElement.textContent = window.Shopify.formatMoney(this.$currentPrice, window.shopMoneyFormat);

            // 如果有比较价格，也更新比较价格
            if (comparePriceElement && this.$currentComparePrice) {
              comparePriceElement.textContent = window.Shopify.formatMoney(
                this.$currentComparePrice,
                window.shopMoneyFormat
              );
            } else {
              if (this.$currentComparePrice == 0) {
                comparePriceElement.textContent = '';
              }
            }
          }
        }
        initSwiper() {
          this.swiper = new Swiper(this.$cartRecommentSwiper, {
            slidesPerView: 1,
            grid: {
              rows: 2,
            },
            spaceBetween: 0,
            pagination: {
              el: '.swiper-pagination',
              clickable: true,
            },
            navigation: {
              nextEl: '.swiper-button-next-recommend',
              prevEl: '.swiper-button-prev-recommend',
            },
          });
        }

        parsePriceString(priceString) {
          if (!priceString) return 0;
          // 移除所有非数字和非小数点的字符，然后转换为数字
          return parseFloat(priceString.replace(/[^0-9.]/g, '')) || 0;
        }

        initJoinCartButton() {
          // 获取所有加入购物车按钮
          const joinCartBtns = this.querySelectorAll('.join-cart-btn');
          if (!joinCartBtns.length) return;

          joinCartBtns.forEach((joinCartBtn) => {
            joinCartBtn.addEventListener('click', async () => {
              try {
                // 获取当前按钮对应的商品容器
                const productContainer = joinCartBtn.closest('.swiper-slide');
                if (!productContainer) {
                  console.error('Cannot find product container');
                  return;
                }

                // 获取当前商品的选择器组件
                const selectMenu = productContainer.querySelector('.select-header');
                if (!selectMenu) {
                  console.error('Cannot find select menu');
                  return;
                }

                // 获取选中的选项
                const selectedOption = productContainer.querySelector('.select-option.selected');
                if (!selectedOption) {
                  window.GlobalPrompt.show('Please select a variant', 'error', 'drawer');
                  return;
                }

                // 获取变体ID和数量
                const variantId = parseInt(selectedOption.getAttribute('data-id'));
                const quantityInput = productContainer.querySelector('input[type="text"]');
                const quantity = quantityInput ? parseInt(quantityInput.value) : 1;

                if (!variantId || isNaN(variantId)) {
                  console.error('Invalid variant ID');
                  return;
                }

                console.log('Adding to cart:', {
                  id: variantId,
                  quantity: quantity,
                });

                const response = await fetch('/cart/add.js', {
                  method: 'POST',
                  headers: {
                    'Content-Type': 'application/json',
                  },
                  body: JSON.stringify({
                    items: [
                      {
                        id: parseInt(variantId),
                        quantity: quantity,
                      },
                    ],
                    sections: 'cart-drawer,cart-icon-bubble',
                  }),
                });
                if (window.gtag) {
                  gtag('event', 'conversion', { send_to: 'AW-11059876179/OfmnCMjGxIsYENOi4Zkp' });
                }
                if (response.ok) {
                  const cartContent = await response.json();
                  await updateCartComponents(cartContent);
                } else {
                  const errorData = await response.json();
                  console.error('Add Cart error:', errorData);
                  window.GlobalPrompt.show(errorData.description || 'Failed to Add to Cart', 'error', 'drawer');
                }
              } catch (error) {
                console.error('Add Cart failed:', error);
                window.GlobalPrompt.show('Failed to Add to Cart', 'error', 'drawer');
              }
            });
          });
        }
      }
    );
  }
});
